export default __webpack_public_path__ + "static/media/album-1.32cffb17.jpg";